export function getBaseUrl() {
if (process.env.NODE_ENV === 'development') {
        return '/api';
    } else { //Prod
        return process.env.PROXY_SERVER;
    }
}